<template>
	<div class="setting-cls">
		<el-tabs tab-position="left">
			<el-tab-pane label="基础设置">
				<Basis :row="row" @onupdate="$emit('onupdate')" />
			</el-tab-pane>
			<el-tab-pane label="成员设置">
				<Member :row="row" />
			</el-tab-pane>
			<el-tab-pane label="高级设置">
				<Advanced :row="row" @closeEmitChange="$emit('closeEmitChange')" />
			</el-tab-pane>
			<el-tab-pane label="公告管理">
				<Announcement :row="row" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import Basis from './Basis';
import Member from './Member';
import Advanced from './Advanced';
import Announcement from './Announcement';
export default {
	props: ['row'],
	components: {Basis, Member, Advanced, Announcement},
}
</script>

<style lang="scss" scoped>
.setting-cls {
	height: 450px;
	overflow: hidden;
	box-sizing: border-box;
	::v-deep .el-tabs {
		width: 100%;
		height: 100%;

		& .el-tabs__content {
			height: 450px;
			overflow-x: hidden;
			overflow-y: auto;
		}
	}
}
</style>